/* Shared by product composition and every bouquet presentation. No editor state. */
(function () {
  const names = {
    white: ['Bianco', 'White'], lightpink: ['Rosa chiaro', 'Light pink'],
    fuchsia: ['Fucsia', 'Fuchsia'], blue: ['Blu', 'Blue'], skyblue: ['Azzurro', 'Sky blue'],
    green: ['Verde', 'Green'], yellow: ['Giallo', 'Yellow'], orange: ['Arancione', 'Orange'], red: ['Rosso', 'Red']
  };
  const aliases = { bianco: 'white', bianca: 'white', rosa: 'lightpink', 'rosa chiaro': 'lightpink', 'rosa chiara': 'lightpink', pink: 'lightpink', 'light pink': 'lightpink', fucsia: 'fuchsia', magenta: 'fuchsia', blu: 'blue', azzurro: 'skyblue', azzurra: 'skyblue', celeste: 'skyblue', 'sky blue': 'skyblue', verde: 'green', giallo: 'yellow', gialla: 'yellow', arancione: 'orange', rosso: 'red', rossa: 'red' };
  const root = 'https://cdn.shopify.com/s/files/1/0887/8332/3459/files/';
  const photo = (file, it, en) => ({ src: root + file + '&width=160', it, en });
  function material(group, value) {
    if (!value?.type) return [];
    const type = String(value.type).toLowerCase();
    const assets = window.FloramePackagingAssets || {};
    if (/tessuto|fabric|satin|raso/.test(type)) {
      const raw = String(value.color || '').trim().toLowerCase();
      const color = names[raw] ? raw : aliases[raw];
      // An unspecified/unknown colour must not pretend to be the saved colour.
      if (!color || !assets[group]?.[color]) return [];
      return [{ src: assets[group][color], it: `${group === 'carta' ? 'Carta tessuto' : 'Nastro'} · ${names[color][0]}`, en: `${group === 'carta' ? 'Fabric paper' : 'Ribbon'} · ${names[color][1]}` }];
    }
    if (group === 'nastro' && /rafia|raffia/.test(type)) return assets.rafia ? [{ src: assets.rafia, ...(assets.rafiaThumb ? { thumbnailSrc: assets.rafiaThumb } : {}), it: 'Rafia naturale', en: 'Natural raffia' }] : [];
    if (group === 'carta' && /grezza|kraft|naturale/.test(type)) return [photo('carta_grezza.jpg?v=1749475887', 'Carta kraft naturale', 'Natural kraft paper')];
    return [];
  }
  window.FloramePackagingPhotos = function (packaging = {}) {
    const decorations = packaging.decorazioni || packaging.decorations || {};
    return {
      paper: material('carta', packaging.carta || packaging.paper),
      ribbon: material('nastro', packaging.nastro || packaging.ribbon),
      decorations: [decorations.verde && photo('Verdefoglie.png?v=1746810810', 'Verde decorativo', 'Decorative greenery'),
        (decorations.nebiolina || decorations.nebbiolina) && photo('nebbiolina.png?v=1746810857', 'Nebbiolina', 'Gypsophila')].filter(Boolean)
    };
  };
  window.FloramePackagingPhotos.fromLabels = function (labels = {}) {
    const parse = (group, entries) => {
      const text = (Array.isArray(entries) ? entries.join(' ') : String(entries || '')).toLowerCase();
      if (/rafia|raffia/.test(text)) return { type: 'rafia' };
      if (/grezza|kraft/.test(text)) return { type: 'grezza' };
      if (!/tessuto|fabric|satin|raso/.test(text)) return {};
      const matches = [...Object.keys(names), ...Object.keys(aliases)].sort((a,b)=>b.length-a.length);
      const match = matches.find(name=>new RegExp('(^|[^a-z])'+name+'(?=$|[^a-z])').test(text));
      return { type: 'tessuto', color: names[match] ? match : aliases[match] };
    };
    const decorations = (labels.decorations || []).join(' ').toLowerCase();
    return { carta: parse('carta', labels.paper), nastro: parse('nastro', labels.ribbon),
      decorazioni: { verde: /verde|greenery/.test(decorations), nebiolina: /nebbi?olina|gypsophila/.test(decorations) } };
  };
})();
